import './LookupFieldMetadata.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { usePeriscopeActions } from '@hooks';
import { LookupFieldEntity, SonarObjectType } from '@sonar-software/sonar-ts-types';

export type LookupFieldMetaDataProps = {
	index: number;
	lookupEntities: LookupFieldEntity[];
};

export const LookupFieldMetaData: React.FC<LookupFieldMetaDataProps> = ({ index, lookupEntities }) => {
	const { openPeriscope } = usePeriscopeActions();

	if (lookupEntities.length === 0) {
		return null;
	}

	return (
		<div className='lookup-field-metadata'>
			{ lookupEntities.map((entity: LookupFieldEntity) => {
				const { displayName, sonarObjectId: id } = entity;
				const [ copyStart, copyEnd ] = COPY_SPECIFIC.A_LOOKUP_ON_OBJECT.split('{0}');

				const objectLink =
					<b
						className='clickable'
						onClick={ () =>
							openPeriscope({
								id,
								name: displayName,
								openedFromIndex: index,
								type: SonarObjectType.SalesforceEntity
							}) }>
						{ displayName }
					</b>;

				return (
					<div key={ id }>
						{ copyStart }
						{ objectLink }
						{ copyEnd }
					</div>
				);
			}) }
		</div>
	);
};
